"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONNECTOR_TYPES = void 0;
var react_device_detect_1 = require("react-device-detect");
var constants_1 = require("../constants");
var connectors_1 = require("./connectors");
/**
 * Connectors for each wallet.
 */
exports.CONNECTOR_TYPES = (_a = {},
    _a[constants_1.WalletTypes.CeloExtensionWallet] = connectors_1.CeloExtensionWalletConnector,
    _a[constants_1.WalletTypes.Injected] = connectors_1.InjectedConnector,
    _a[constants_1.WalletTypes.Ledger] = connectors_1.LedgerConnector,
    _a[constants_1.WalletTypes.MetaMask] = connectors_1.MetaMaskConnector,
    _a[constants_1.WalletTypes.PrivateKey] = connectors_1.PrivateKeyConnector,
    _a[constants_1.WalletTypes.Unauthenticated] = connectors_1.UnauthenticatedConnector,
    _a[constants_1.WalletTypes.Valora] = react_device_detect_1.isMobile ? connectors_1.ValoraConnector : connectors_1.WalletConnectConnector,
    _a[constants_1.WalletTypes.WalletConnect] = connectors_1.WalletConnectConnector,
    _a[constants_1.WalletTypes.CeloTerminal] = connectors_1.WalletConnectConnector,
    _a[constants_1.WalletTypes.CeloWallet] = connectors_1.WalletConnectConnector,
    _a);
//# sourceMappingURL=connectors-by-name.js.map